module.exports = __webpack_public_path__ + "static/media/sql.c02ade79.svg";